import React from 'react';
import {observer} from 'mobx-react';
import MainView from './MainView';
import Login from './Login';
import {Store} from '../stores/store';
import {ToastContainer} from 'react-toastify';
import {stylesheet} from 'typestyle';
import {StoreProvider} from '../inject';
import * as i18next from 'i18next';
import I18nextProvider from 'react-i18next/src/I18nextProvider';
import {DragDropContext, DragStart, DropResult} from 'react-beautiful-dnd';
import {DroppablePrefix} from '../beautiful-dnd/Droppable';

@observer
export default class AnalyticsApp extends React.Component<{store: Store; i18n: i18next.i18n}> {
    public componentDidMount() {
        this.props.store.initialLogin();
    }

    private onDragEnd = (result: DropResult) => {
        const {destination, source, combine} = result;
        if (source) {
            if (source.droppableId.startsWith(DroppablePrefix.REPORT)) {
                return this.props.store.reportEditorStore.dropEvents(source, destination, combine);
            } else {
                throw Error(`Could not assign droppable id "${source.droppableId}" to known source`);
            }
        }
    };

    private onDragStart = (dragStart: DragStart) => {
        const {source} = dragStart;
        if (source) {
            if (source.droppableId.startsWith(DroppablePrefix.REPORT)) {
                return this.props.store.reportEditorStore.dragStartEvents(source.droppableId);
            }
        }
    };

    public render() {
        let view = <div>Logging in ...</div>;
        if (!this.props.store.autologin) {
            if (this.props.store.loggedIn) {
                view = <MainView store={this.props.store} />;
            } else {
                view = <Login />;
            }
        }
        return (
            <StoreProvider store={this.props.store}>
                <I18nextProvider i18n={this.props.i18n}>
                    <DragDropContext onDragStart={this.onDragStart} onDragEnd={this.onDragEnd}>
                        <div className={mainCss.mainViewContainer}>
                            {view}
                            <ToastContainer />
                        </div>
                    </DragDropContext>
                </I18nextProvider>
            </StoreProvider>
        );
    }
}

const mainCss = stylesheet({
    mainViewContainer: {
        height: '100%',
    },
});



// WEBPACK FOOTER //
// ./src/views/AnalyticsApp.tsx